import { Fragment } from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';

/**
 * Payment Element: mostra dinamicamente i metodi di pagamento realmente
 * disponibili per il cliente (carte, wallet, Klarna, SEPA, Satispay...) in
 * base alla configurazione Stripe dashboard + paese/valuta/importo/dispositivo.
 */
const StripeElement = () => {
	return (
		<Fragment>
			<PaymentElement
				options={{
					layout: 'tabs',
				}}
			/>
		</Fragment>
	);
};

export default StripeElement;
